import React from 'react';
import { Panel } from 'react-bootstrap';

const Card = ({ color, title, children, className, ...rest }) => {
    const colorClassName = color ? `card-${color}` : '';

    return <Panel className={`card ${colorClassName} ${className || ''}`} {...rest}>
        <Panel.Body className='card-body'>
            {title && <h4 className='text-muted'>{title}</h4>}
            {children}
        </Panel.Body>
    </Panel >
};

export default Card;